enum Paths {
  ANNOUNCEMENTS = 'announcements',
  COMMON_ROOM = 'common-room',
  FEED = 'feed',
}

export default Paths;
